import { PAYMENT_METHOD_STATUS } from './constants';

export const isPaymentMethodCreated = (paymentMethod) => {
    const { status } = paymentMethod;

    return status === PAYMENT_METHOD_STATUS.CREATED;
};

export default class PaymentAPIService {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }

    getPaymentGateways(storeCode) {
        return this.axiosInstance.get(`/stores/${storeCode}/payment_gateways`);
    }

    registerPaymentMethod(paymentGatewayId, payload) {
        return this.axiosInstance.post(`payments/${paymentGatewayId}/payment_methods`, payload);
    }

    getPaymentMethodStatus(userId, paymentId) {
        return this.axiosInstance.get(`users/${userId}/payment_methods/${paymentId}`);
    }
}
